import { t } from "i18next";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { maintenanceType } from "../../../../enums";
import { useFetch } from "../../../../hooks/useFetch";
import { useAppStore } from "../../../../stores/RootStore";
import { Division, SelectOptions } from "../../../../types/types";
import { Button } from "../../../../ui/Button";
import { DatePicker } from "../../../../ui/Datepicker/DatePicker";
import { Input } from "../../../../ui/Input/Input";
import { Label } from "../../../../ui/Label/Label";
import { ScrollArea } from "../../../../ui/ScrollArea/ScrollArea";
import { SelectButton } from "../../../../ui/SelectButton/SelectButton";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "../../../../ui/Dialog";
import { Textarea } from "../../../../ui/TextArea/Textarea";

const AddService = () => {
  const maintenanceTypes = maintenanceType.map((type) => ({ label: t(`maintenance_${type}`), value: type }));
  
  const equipments = useAppStore((store) => store.equipments);
  const equipmentsList = equipments?.map((equipment) => {
    return { value: equipment.id, label: equipment.attributes.name };
  })!;
  const [equipmentId, setEquipmentId] = useState('');

  const divisions = useAppStore((store) => store.divisions)!;
  const divisionsList = divisions?.map((division) => {
    return { value: division.id, label: division.attributes.name };
  })!;

  const [errors, setErrors] = useState([]);
  const { register, reset, handleSubmit, control } = useForm({
    defaultValues: {
      equipment: { value: "", label: "" },
      maintenance_type: { value: "", label: "" },
      maintenance_previous_date: undefined,
      maintenance_name: "",
      maintenance_time: "",
      maintenance_description: "",
    },
  });

  const [{ response: itemSaveResponse, isLoading: itemSaveIsLoading, error: itemSaveError }, doFetchItemSave] =
    useFetch(`/directories/equipment_items/${equipmentId}/maintenances`);

  const onSubmit = (formData: any) => {
    doFetchItemSave({
      method: "POST",
      data: {
        data: {
          description: formData.maintenance_name,
          maintenance_description: formData.maintenance_description,
          maintenance_time: formData.maintenance_time,
          maintenance_type: formData.maintenance_type.value,
          previous_maintenance_at: formData.maintenance_previous_date,
        },
      },
    });
    reset();
  };

  const setDivisions = useAppStore((store) => store.setDivisions);

  const addDivision = (itemSaveResponse: { data: unknown }) => {
    const newDivisionData = itemSaveResponse.data as unknown as Division;
    setDivisions([...divisions, newDivisionData]);
  };

  useEffect(() => {
    if (!itemSaveResponse) return;
    // addDivision(itemSaveResponse);
  }, [itemSaveResponse]);

    function handleChangeEquipment(
      value: { value: string; label: string } | null,
      onChange: { (...event: any[]): void; (arg0: any): void }
    ) {
      if (!value) return
      setEquipmentId(value?.value);
      onChange(value?.value);
    }

  return (
    <ScrollArea className="w-full">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="grid grid-cols-1 w-full pt-8 h-full gap-3">
            <Controller
              name="equipment"
              control={control}
              rules={{ required: true }}
              render={({ field: { value, onChange } }) => (
                <div className="relative flex flex-col space-y-2">
                  <Label>{t("equipment")}*</Label>
                  <SelectButton
                    label={"Выберите оборудование"}
                    searchable={true}
                    options={equipmentsList}
                    value={value ? equipmentsList?.find((s) => s.value == String(value))! : null}
                    onChange={(e) => handleChangeEquipment(e, onChange)}
                  />
                </div>
              )}
            />

            <Controller
              name="maintenance_name"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <div className="relative flex flex-col space-y-2">
                  <Label>{t("maintenance_name")}*</Label>
                  <Input {...field} />
                </div>
              )}
            />

            <Controller
              name="maintenance_type"
              control={control}
              rules={{ required: true }}
              render={({ field: { value, onChange } }) => (
                <div className="relative flex flex-col space-y-2">
                  <Label>{t("maintenance_type")}*</Label>
                  <SelectButton
                    label={"Выберите тип эксплуатации"}
                    searchable={false}
                    options={maintenanceTypes}
                    value={value ? maintenanceTypes?.find((s) => s.value == String(value))! : null}
                    onChange={onChange}
                  />
                </div>
              )}
            />

            <Controller
              name="maintenance_time"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <div className="relative flex flex-col space-y-2">
                  <Label>{t("maintenance_time")}*</Label>
                  <Input {...field} />
                </div>
              )}
            />

            <Controller
              name="maintenance_previous_date"
              control={control}
              rules={{ required: true }}
              render={({ field: { value, onChange } }) => (
                <div className="relative flex flex-col space-y-2">
                  <Label>{t("previous_maintenance_at")}*</Label>
                  <DatePicker mode="single" selected={value} onSelect={onChange} />
                </div>
              )}
            />

            <Controller
              name="maintenance_description"
              control={control}
              render={({ field }) => (
                <div className="relative flex flex-col space-y-2">
                  <Label>{t("maintenance_description")}</Label>
                  <Textarea {...field} />
                </div>
              )}
            />

            <Button type="submit" className="mt-8">
              {t("save")}
            </Button>
          </div>
        </form>
    </ScrollArea>
  );
};

export default AddService;
